import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

const Login = () => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const isAuthenticated = localStorage.getItem("isAuthenticated");
    if (isAuthenticated === "true") {
      navigate("/Dashboard");
    }
  }, [navigate]);

  const handleLogin = (e) => {
    e.preventDefault();

    if (password === "RC_P@ssw0rd!") {
      localStorage.setItem("isAuthenticated", "true"); // Save login state
      navigate("/Dashboard"); // Redirect to Dashboard
    } else {
      setError("Incorrect Password! Try Again.");
    }
  };

  return (
    <div className="container-fluid">
      <div className="row" style={{ background: "#003E32", height: "100px" }}>
        <div className="col-md-3">
          <img
            src="./Logo.png"
            alt=""
            style={{ marginTop: "27px", marginLeft: "30px" }}
          />
        </div>
      </div>
      <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
        <div className="card p-4 shadow" style={{ width: "350px" }}>
          <h3 className="text-center">Login</h3>
          <form onSubmit={handleLogin}>
            <div className="mb-3">
              <input
                type="password"
                className="form-control"
                placeholder="Enter Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            {error && <div className="alert alert-danger p-2">{error}</div>}
            <button type="submit" className="btn btn-primary w-100">
              Login
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
